module.exports = __webpack_public_path__ + "img/swiper6.697b78e0.png";